import React from "react";
import { motion } from "framer-motion";
import { crmAnalyticsWidgets } from "../../data/crmPageContent";
import { CrmAnalyticsDashboard, CrmChartPanel } from "./CrmMockups";
import { CrmReveal } from "./CrmMotion";

export const CrmAnalyticsSection = () => (
    <section className="crm-analytics-v2">
        <div className="crm-container">
            <CrmReveal className="crm-analytics-v2__header">
                <h2 className="crm-h2">Analytics &amp; Insights</h2>
                <div className="crm-section-accent crm-section-accent--center" />
                <p className="crm-lead">
                    Revenue trends, sales performance, lead sources, conversion metrics, and team
                    productivity — visualized in premium CRM Analytics dashboards.
                </p>
            </CrmReveal>

            <div className="crm-analytics-v2__layout">
                <CrmReveal className="crm-analytics-v2__main">
                    <CrmAnalyticsDashboard />
                </CrmReveal>

                <div className="crm-analytics-v2__side">
                    <CrmReveal delay={0.08}>
                        <CrmChartPanel />
                    </CrmReveal>

                    <CrmReveal delay={0.14} className="crm-analytics-v2__widgets">
                        {crmAnalyticsWidgets.map((w) => {
                            const Icon = w.icon;
                            return (
                                <motion.div
                                    key={w.title}
                                    className="crm-analytics-v2__widget"
                                    whileHover={{ y: -4, boxShadow: "0 12px 32px rgba(0,0,0,0.2)" }}
                                >
                                    <div className="crm-analytics-v2__widget-head">
                                        <Icon size={15} />
                                        <span>{w.title}</span>
                                    </div>
                                    <strong>{w.metric}</strong>
                                    <em>{w.change}</em>
                                </motion.div>
                            );
                        })}
                    </CrmReveal>
                </div>
            </div>
        </div>
    </section>
);
